import { useState } from "react";
import CrudTable from "../components/CrudTable";
import PDFButton from "../components/PDFButton";
import ProgramRichForm from "../components/ProgramRichForm";

const TABS = [
  { key: "esg_complaints", label: "Quejas y Denuncias" },
  { key: "esg_sustainability_reports", label: "Reportes de Sostenibilidad" },
  { key: "esg_materiality", label: "Estudios de Materialidad" },
  { key: "esg_climate", label: "Eventos Climáticos" },
  { key: "esg_campaigns", label: "Campañas y Acciones" },
  { key: "esg_programs", label: "Programas Ambientales" },
];

const fieldsByColl = {
  esg_complaints: [
    { key: "date", label: "Fecha", type: "date" },
    { key: "folio", label: "Folio" },
    { key: "description", label: "Descripción", type: "textarea", full: true },
    { key: "origin", label: "Origen", type: "select", options: ["Empleados", "Contratistas", "Clientes", "Autoridad", "Otro"] },
    { key: "channel", label: "Medio de recepción", type: "select", options: ["Llamada", "Texto", "Correo", "Otro"] },
    { key: "responsible", label: "Responsable" },
    { key: "status", label: "Status", type: "select", options: ["Abierta", "En investigación", "Cerrada"] },
  ],
  esg_sustainability_reports: [
    { key: "title", label: "Título", required: true, full: true },
    { key: "year", label: "Año", type: "number" },
    { key: "framework", label: "Marco / Estándar", type: "select", options: ["GRI","SASB","TCFD","CDP","ISO 26000","Local","Otro"] },
    { key: "period", label: "Período" },
    { key: "publication_date", label: "Fecha publicación", type: "date" },
    { key: "responsible", label: "Responsable" },
    { key: "status", label: "Status", type: "select", options: ["Borrador","Revisión","Publicado","Archivado"] },
    { key: "comments", label: "Comentarios", type: "textarea", full: true },
  ],
  esg_materiality: [
    { key: "title", label: "Título del estudio", required: true, full: true },
    { key: "year", label: "Año", type: "number" },
    { key: "methodology", label: "Metodología" },
    { key: "lead", label: "Responsable / Líder" },
    { key: "stakeholders", label: "Grupos de interés involucrados", type: "textarea", full: true },
    { key: "topics_count", label: "# temas materiales", type: "number" },
    { key: "publication_date", label: "Fecha publicación", type: "date" },
    { key: "status", label: "Status", type: "select", options: ["Planeado","En proceso","Concluido","Archivado"] },
    { key: "comments", label: "Comentarios / hallazgos", type: "textarea", full: true },
  ],
  esg_climate: [
    { key: "code", label: "# Evento" },
    { key: "date", label: "Fecha", type: "date" },
    { key: "location", label: "Ubicación" },
    { key: "description", label: "Descripción", type: "textarea", full: true },
    { key: "affected_processes", label: "Procesos afectados" },
    { key: "contingency_cost", label: "Costos contingencia $", type: "number" },
    { key: "estimated_losses", label: "Pérdidas estimadas $", type: "number" },
    { key: "lesson", label: "Lección aprendida", type: "textarea", full: true },
  ],
  esg_campaigns: [
    { key: "code", label: "# Campaña" },
    { key: "description", label: "Descripción", type: "textarea", full: true, required: true },
    { key: "date", label: "Fecha", type: "date" },
    { key: "cost", label: "Costo $", type: "number" },
    { key: "objective_link", label: "Objetivo relacionado" },
    { key: "status", label: "Status", type: "select", options: ["Planeada", "En ejecución", "Cerrada"] },
  ],
  esg_programs: [
    { key: "name", label: "Nombre", required: true },
    { key: "objective", label: "Objetivo", type: "textarea", full: true },
    { key: "period", label: "Período" },
    { key: "status", label: "Status", type: "select", options: ["Activo", "Pausado", "Cerrado"] },
  ],
};

export default function ESG() {
  const [tab, setTab] = useState("esg_complaints");
  return (
    <div data-testid="esg-module">
      <div className="flex items-center justify-between mb-3">
        <h1 className="card-h1" style={{ margin: 0 }}>ESG / RSE</h1>
        <PDFButton endpoint="/pdf/module/esg_complaints" filename="reporte_esg.pdf" label="Reporte PDF" />
      </div>
      <div className="tabs-bar">
        {TABS.map((t) => (
          <button key={t.key} className={`tab ${tab === t.key ? "active" : ""}`} onClick={() => setTab(t.key)} data-testid={`esg-tab-${t.key}`}>{t.label}</button>
        ))}
      </div>
      {tab === "esg_programs" ? (
        <ProgramRichForm collection="esg_programs" testIdPrefix="esg_programs" title="Programa Ambiental" />
      ) : tab === "esg_campaigns" ? (
        <ProgramRichForm collection="esg_campaigns" testIdPrefix="esg_campaigns" title="Campaña / Acción ESG" />
      ) : (
        <CrudTable collection={tab} testIdPrefix={tab} fields={fieldsByColl[tab]} />
      )}
    </div>
  );
}
